<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LXovxA/tc-custom/9781467443272.jpg?1728851764886" alt="This image is the cover for the book The Election of Grace, Kantzer Lectures in Revealed Theology (KLRT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Election of Grace, Kantzer Lectures in Revealed Theology (KLRT)
      </h1>
      <p class="bookDescription body article font2">
        <p>Few issues in Christian theology have sparked as much controversy over the centuries as the question of election. In this book -- the inaugural volume of the Kantzer Lectures in Revealed Theology series -- Stephen Williams offers a rich and nuanced account of the doctrine of election, arguing that we should diminish the role of “system” in Christian theology.<br/><br/>After expounding the Bible’s teaching on election, Williams turns to questions of theological method and substance. He maintains that the subject of predestination must be considered in a wider biblical context than it often is and that we cannot expect to understand election within a comprehensive systematic framework. What matters is the relation of particular truths to the particulars of life, he says, not the systematic relation of truths to each other. Williams draws on and applies the insights of remarkable nineteenth-century Anglican leader Charles Simeon throughout his study, concluding the book with a cogent discussion of Karl Barth on election.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen N. Williams
      </h2>
      
      <p class="authorDescription body article">Stephen Williams is professor of systematic theology atUnion Theological College, Belfast, Northern Ireland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4122a208